export default {
      id: "happy-message-usage",
      viewBox: "0 0 193 70",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#happy-message-usage",
      toString: function () {
        return this.url;
      }
    }